import React, { useEffect, useState } from "react";
import { Button } from "bootstrap-4-react/lib/components";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import LoaderSpinner from "../common/Loader";
import { getDropshipSetting, upsertDropshipSetting } from "../../store/actions/dropship.action";

export default function DropshipSettings() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userDetails = useSelector((state) => state.auth.user);
    const { setting, settingLoading } = useSelector((state) => state.dropshipReducer);
    const [isEnabled, setIsEnabled] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (userDetails?.Value) {
            dispatch(getDropshipSetting({}));
        }
    }, [userDetails]);

    useEffect(() => {
        if (setting) {
            setIsEnabled(setting.isDropshipEnabled || false);
        }
    }, [setting]);

    const handleAction = () => {
        const newValue = !isEnabled;
        setSubmitting(true);
        dispatch(upsertDropshipSetting({ isDropshipEnabled: newValue }))
            .then(() => {
                setIsEnabled(newValue);
                toast.success(
                    newValue
                        ? "Dropshipping enabled. Explore menu is now available."
                        : "Dropshipping disabled."
                );
            })
            .catch(() => {
                toast.error("Failed to update dropshipping setting.");
            })
            .finally(() => {
                setSubmitting(false);
            });
    };

    const getButtonLabel = () => {
        if (submitting) return "Saving...";
        return isEnabled ? "Disable Dropshipping" : "Enable Dropshipping";
    };

    return (
        <main>
            <div className="main__container">
                <div className="main__tile_heading cus-btn-include-sec">
                    Dropshipping Settings
                    <div className="top_right_button_container">
                        <Button
                            className="cus-primary-transparent-btn"
                            onClick={() => navigate("/setting")}
                        >
                            Back
                        </Button>
                    </div>
                </div>

                {(settingLoading || submitting) && (
                    <div className="full-screen-spinner-overlay">
                        <LoaderSpinner />
                    </div>
                )}

                <div className="main_content_table">
                    <div className="row" style={{ padding: "24px", margin: 0 }}>
                        <div className="col-lg-8 col-md-12 col-sm-12">
                            <h5 style={{ marginBottom: 8 }}>Dropshipping Status</h5>
                            <p style={{ color: "#666", fontSize: 14, marginBottom: 16 }}>
                                When enabled, you can browse and import products from other sellers
                                to resell on your own storefront. Other sellers can also browse and
                                import your listed products. You can change this anytime.
                            </p>
                            <div style={{ marginBottom: 8 }}>
                                <strong>Current status:</strong>{" "}
                                <span style={{ color: isEnabled ? "#28a745" : "#dc3545", fontWeight: 600 }}>
                                    {isEnabled ? "Enabled" : "Disabled"}
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-12 col-sm-12 d-flex align-items-center justify-content-end">
                            <Button
                                className={isEnabled ? "cus-primary-transparent-btn" : "cus-seconday-bg-btn"}
                                onClick={handleAction}
                                disabled={submitting || settingLoading}
                            >
                                {getButtonLabel()}
                            </Button>
                        </div>
                    </div>

                </div>
            </div>
        </main>
    );
}
